var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _ellipse, _path46, _ellipse2, _ellipse3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtc01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.189453,
    y: 0.529297,
    width: 350,
    height: 233,
    fill: "#974444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.639 187.097C216.912 191.351 225.557 192.005 231.048 192.005C235.624 191.746 237.296 189.555 237.142 188.604C236.863 186.88 237.469 185.805 235.089 183.219C232.708 180.634 218.838 171.801 212.111 168.892C205.383 165.983 198.028 164.732 195.239 167.491C193.304 169.407 193.682 172.711 195.239 175.671C196.447 177.969 201.581 183.467 208.639 187.097Z",
    fill: "#0F0D22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.514 151.121C269.881 157.534 278.378 156.972 282.024 156.972C288.214 156.781 290.26 154.019 290.117 153.188C289.858 151.68 290.42 150.74 288.214 148.479C286.009 146.219 273.158 138.495 266.924 135.951L266.896 135.94C260.665 133.398 252.303 129.986 249.723 132.396C247.93 134.07 248.736 139.237 250.179 141.826C251.622 144.414 253.341 147.302 259.514 151.121Z",
    fill: "#0F0D22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.318 146.307C179.022 144.552 177.51 140.929 177.51 137.605C177.685 133.026 178.891 135.981 179.805 135.981C180.719 135.981 182.817 139.79 183.426 143.007C184.036 146.224 198.522 161.826 186.717 153.088C183.646 150.814 181.594 148.036 180.335 146.331L180.318 146.307Z",
    fill: "#0F0D22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.93 167.767L209.184 163.172L210.986 164.448C212.03 165.187 212.174 166.256 211.533 167.16C210.884 168.077 209.828 168.277 208.768 167.527L207.943 166.943L206.882 168.441L205.93 167.767ZM208.486 166.175L209.159 166.651C209.724 167.051 210.225 166.929 210.55 166.464C210.876 166.009 210.818 165.506 210.256 165.103L209.583 164.626L208.486 166.175Z",
    fill: "#AAA0E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.256 170.915C209.958 170.704 209.885 170.295 210.101 170.005C210.301 169.708 210.711 169.641 211.007 169.855C211.291 170.052 211.367 170.463 211.16 170.755C210.951 171.05 210.539 171.115 210.256 170.915Z",
    fill: "#AAA0E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.598 171.779L214.851 167.185L216.653 168.461C217.697 169.2 217.841 170.269 217.201 171.173C216.551 172.09 215.495 172.29 214.435 171.54L213.61 170.956L212.55 172.453L211.598 171.779ZM214.154 170.188L214.826 170.664C215.391 171.064 215.892 170.942 216.217 170.477C216.544 170.022 216.485 169.519 215.923 169.115L215.25 168.639L214.154 170.188Z",
    fill: "#AAA0E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.82 170.703L216.567 175.298L215.628 174.633L218.881 170.038L219.82 170.703Z",
    fill: "#AAA0E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.808 176.99C217.754 176.238 217.59 175.098 218.366 174.008C219.115 172.943 220.282 172.688 221.291 173.402C222.196 174.043 222.505 175.119 221.674 176.293L221.485 176.56L219.131 174.893C218.762 175.413 218.843 175.952 219.326 176.299C219.649 176.522 219.976 176.545 220.214 176.403L221.109 177.037C220.524 177.581 219.661 177.589 218.808 176.99ZM219.548 174.303L221.014 175.341C221.308 174.92 221.233 174.414 220.811 174.12C220.382 173.812 219.848 173.92 219.548 174.303Z",
    fill: "#AAA0E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.871 187.706C218.857 191.652 227.204 192.259 232.505 192.259C236.922 192.019 238.537 189.986 238.388 189.105C238.118 187.505 238.704 186.508 236.406 184.11C234.107 181.711 220.717 173.518 214.222 170.82C207.727 168.122 200.626 166.961 197.934 169.521C196.066 171.297 196.431 174.362 197.934 177.108C199.1 179.24 204.057 184.339 210.871 187.706Z",
    fill: "#17161E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.247 148.52C274.049 155.324 282.902 154.727 286.701 154.727C293.152 154.525 295.283 151.595 295.134 150.714C294.864 149.114 295.45 148.117 293.152 145.718C290.853 143.32 277.463 135.127 270.968 132.428L270.939 132.416C264.446 129.72 255.734 126.1 253.046 128.657C251.178 130.433 252.017 135.914 253.521 138.66C255.024 141.405 256.816 144.47 263.247 148.52Z",
    fill: "#17161E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.702 143.347C176.536 141.724 175.176 138.372 175.176 135.296C175.333 131.06 176.418 133.794 177.24 133.794C178.063 133.794 179.95 137.318 180.498 140.294C181.046 143.27 194.077 157.706 183.458 149.621C180.695 147.518 178.85 144.947 177.718 143.37L177.702 143.347Z",
    fill: "#17161E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.008 134.414C175.478 144.455 189.149 154.34 195.926 158.027L195.654 146.652C193.411 145.103 188.254 142.053 181.898 136.391C176.813 131.862 175.186 123.786 175.008 120.314V134.414Z",
    fill: "#315317"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.945 158.043L195.664 146.928L197.787 145.387L197.903 156.223L195.945 158.043Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.287 156.227L196.1 148.53L197.463 147.414L197.568 155.067L196.287 156.227Z",
    fill: "#A3A3A3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.287 156.225L196.1 148.527L202.519 152.116L201.615 159.206L196.287 156.225Z",
    fill: "#698B4F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290.867 144.758C291.688 146.011 291.85 148.991 290.865 151.289",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M292.631 145.887C292.995 146.659 293.505 148.739 292.631 150.884",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M303.045 138.84C304.218 139.046 306.374 140.191 305.608 143.119",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M304.629 140.738C304.928 141.027 305.436 142.042 305.077 143.788",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.465 127.877C305.954 127.638 307.063 127.189 307.589 127.309",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M305.914 126.475C306.153 126.345 306.739 126.085 307.17 126.086",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M301.824 132.444C302.415 132.242 303.749 131.958 304.358 132.444",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M301.969 131.632C302.178 131.443 302.943 131.057 304.326 131.02",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M275.19 111.898C275.199 111.039 275.029 109.057 274.273 108.004",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.705 111.754C275.886 110.79 276.037 108.478 275.189 106.943",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M291.875 116.171C292.041 115.431 292.644 113.835 293.73 113.365",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M292.447 116.728C292.662 116.007 293.464 114.367 294.952 113.578",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.519 189.013C242.234 189.216 241.372 189.435 240.201 188.688",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M243.304 188.341C243.031 188.488 242.335 188.639 241.734 188.066",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.282 176.902C248.872 177.005 247.656 177.148 246.072 176.902",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M249.382 176.082C248.95 176.196 247.819 176.355 246.754 176.082",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M242.408 183.148C242.665 183.593 243.44 184.528 244.489 184.709",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242.654 182.629C242.805 182.991 243.346 183.746 244.305 183.873",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M223.179 141.313C218.434 140.811 214.503 143.616 213.131 145.081C216.992 157.525 222.149 183.435 222.707 187.287C223.405 192.102 238.208 193.119 242.465 189.211C245.935 186.389 249.183 180.936 249.696 173.761C250.115 167.903 246.625 157.433 241.043 151.152C235.46 144.872 229.11 141.941 223.179 141.313Z",
    fill: "#141414"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M214.627 144.037C212.571 144.548 212.428 145.855 211.76 146.712C218.23 161.165 230.117 189.924 232.236 190.59C234.885 191.422 240.922 187.83 242.973 181.275C244.816 176.205 243.921 169.244 242.354 164.97C239.326 156.712 233.174 149.724 227.124 146.224C220.958 142.657 215.54 143.811 214.627 144.037Z",
    fill: "#315317"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M213.163 144.724L204.172 150.244C204.088 158.12 205.32 175.331 210.916 181.163C217.911 188.453 223.97 190.079 229.241 190.916C234.511 191.754 237.845 188.07 238.84 186.876L238.868 186.842C240.282 185.148 243.881 180.832 242.729 170.734C240.002 158.153 232.015 150.84 226.462 147.274C221.542 144.115 215.616 144.082 213.163 144.724Z",
    fill: "#1E221A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M202.597 152.156L196.1 148.53L197.463 147.414L203.878 150.996L202.597 152.156Z",
    fill: "#CDDFBF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M258.141 121.901L258.139 107.204L259.98 105.318L259.982 120.163L258.141 121.901Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M194.998 119.046C186.293 123.561 181.952 131.3 182.956 135.447C179.681 132.165 178.479 130.524 178.163 128.993C177.159 125.427 175.237 119.464 180.055 114.583C186.076 108.483 193.334 104.802 204.217 102.232C213.369 100.072 225.791 99.248 237.591 100.849C247.184 102.15 255.736 105.119 258.14 106.888V121.754C254.748 120.653 251.471 119.018 235.626 115.611C219.78 112.205 205.279 113.714 194.998 119.046Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M208.934 148.667C199.992 149.175 199.666 159.302 200.258 164.41C201.271 170.026 204.052 174.164 207.246 178.011C217.402 189.716 226.751 187.813 228.864 186.709C231.101 185.541 236.523 180.579 235.028 172.227C233.88 165.809 228.376 158.984 225.993 156.562C223.568 154.099 217.231 148.197 208.934 148.667Z",
    fill: "#1E221A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M209.214 153.873C199.959 154.018 200.246 162.614 201.547 166.895C204.723 176.197 212.945 182.629 216.201 184.042C219.9 185.648 227.77 185.267 229.63 179.913C231.49 174.56 229.154 169.421 228.714 168.452C228.488 167.957 220.783 153.692 209.214 153.873Z",
    fill: "#315317"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M264.957 112.638L258.459 109.012L259.823 107.896L266.237 111.479L264.957 112.638Z",
    fill: "#CDDFBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M258.646 119.297L258.459 109.014L264.878 112.603L263.974 122.278L258.646 119.297Z",
    fill: "#698B4F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M197.803 145.383L195.662 146.924C183.696 140.788 178.192 133.517 176.27 128.357C172.69 118.748 177.764 113.954 180.748 111.177C184.186 107.706 194.09 100.962 207.944 99.1653C215.263 98.2159 221.093 97.6535 229.65 98.1529C246.553 99.4154 256.9 103.447 259.969 105.317L258.115 107.218C256.151 106.095 249.054 103.784 245.605 103.004C240.495 101.943 227.8 100.009 217.895 100.764C205.514 101.707 200.134 103.182 197.776 104.125C195.417 105.068 189.017 107.034 183.79 111.515C179.104 115.531 177.862 117.892 177.498 120.28C176.353 132.166 190.979 142.07 197.803 145.383Z",
    fill: "#CDDFC0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M252.78 130.218C252.669 129.055 253.702 125.446 254.232 123.787L255.823 126.761L263.154 138.033C268.133 141.03 278.147 147.065 278.368 147.231C278.589 147.397 291.277 146.655 297.594 146.263C300.521 144.142 306.128 140.592 305.132 143.358C303.887 146.816 298.631 154.977 283.347 154.354C268.064 153.732 259.82 145.237 256.567 140.848C253.519 136.735 252.918 131.671 252.78 130.218Z",
    fill: "#315317"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.047,
    cy: 128.887,
    rx: 28.6474,
    ry: 21.4654,
    transform: "rotate(22.8984 281.047 128.887)",
    fill: "#141414"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M262.752 142.304C262.871 141.518 263.338 139.761 264.251 139.02",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.588,
    cy: 125.314,
    rx: 13.4436,
    ry: 8.16997,
    transform: "rotate(22.8984 281.588 125.314)",
    fill: "#27321B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.923,
    cy: 127.166,
    rx: 11.4908,
    ry: 6.98324,
    transform: "rotate(22.8984 282.923 127.166)",
    fill: "#141414"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.174 136.866C288.396 141.184 298.809 139.648 301.433 133.436C304.056 127.224 297.897 118.688 287.676 114.371C277.454 110.054 267.041 111.589 264.417 117.801C261.793 124.013 267.953 132.549 278.174 136.866ZM280.206 132.049C286.052 134.518 292.008 133.64 293.508 130.087C295.009 126.534 291.486 121.652 285.64 119.183C279.794 116.714 273.838 117.592 272.338 121.145C270.837 124.698 274.36 129.58 280.206 132.049Z",
    fill: "#315317"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M253.592 126.582C253.894 125.41 254.959 122.863 256.804 122.051",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M254.146 129.309C254.289 128.261 254.867 126.024 256.038 125.453",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M261.861 141.588C262.111 140.303 263.132 137.34 265.217 135.77",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M261.016 140.788C261.082 139.566 261.705 136.895 263.666 135.984",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M278.148 136.926C278.169 137.761 277.996 139.716 277.133 140.859",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M278.947 137.27C279.042 137.608 279.176 138.475 278.947 139.236",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M236.126 146.707C235.767 146.758 234.993 147.019 234.771 147.66",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M235.539 146.23C234.983 146.422 233.758 147.004 233.301 147.803",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M245.653 158.633C245.231 158.762 244.141 159.167 243.166 159.753",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M246.126 159.258C245.801 159.367 245.012 159.69 244.459 160.113",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M220.445 143.722C220.4 143.306 220.546 142.361 221.482 141.914",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M220.98 143.88C221.007 143.569 221.194 142.884 221.726 142.629",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M228.986 147.258C229.111 146.886 229.513 146.114 230.131 146.008",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M237.9 156.255C238.202 155.856 239.002 155.026 239.79 154.898",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M238.111 156.578C238.395 156.294 239.08 155.694 239.548 155.566",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.334 164.783L211.252 161.164L212.612 162.636C213.441 163.534 213.337 164.518 212.588 165.216C211.836 165.905 210.844 165.924 210.009 165.02L209.31 164.262L207.984 165.487L207.334 164.783ZM209.889 163.727L210.498 164.387C210.991 164.915 211.509 164.878 211.923 164.496C212.342 164.109 212.412 163.603 211.922 163.073L211.312 162.412L209.889 163.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.645 168.455C210.43 168.222 210.442 167.855 210.677 167.643C210.902 167.43 211.266 167.45 211.484 167.68C211.688 167.907 211.679 168.271 211.452 168.481C211.219 168.696 210.852 168.679 210.645 168.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.718 169.529L215.636 165.91L216.996 167.382C217.826 168.281 217.721 169.264 216.972 169.962C216.22 170.652 215.228 170.67 214.393 169.766L213.694 169.008L212.368 170.233L211.718 169.529ZM214.273 168.473L214.883 169.134C215.375 169.661 215.893 169.625 216.307 169.242C216.726 168.855 216.796 168.349 216.306 167.819L215.696 167.159L214.273 168.473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.405 169.991L215.487 173.61L214.847 172.917L218.765 169.298L219.405 169.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.242 175.629C216.425 174.745 216.512 173.656 217.432 172.806C218.341 171.966 219.468 171.948 220.243 172.787C220.908 173.507 221.031 174.547 220 175.499L219.784 175.699L217.889 173.648C217.398 174.121 217.373 174.691 217.788 175.135C218.066 175.441 218.383 175.524 218.641 175.45L219.266 176.127C218.642 176.472 217.872 176.311 217.242 175.629ZM218.362 173.216L219.645 174.604C220.042 174.231 220.085 173.691 219.717 173.293C219.335 172.879 218.758 172.895 218.362 173.216Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc01);
export default __webpack_public_path__ + "static/media/etc_01.77902be8ee4093383ffe8c9645c44580.svg";
export { ForwardRef as ReactComponent };